import { type ComponentType, lazy, Suspense } from 'react';
import { Loader } from '../Loader/Loader';

export const LazyLoadable =
  // biome-ignore lint/suspicious/noExplicitAny: we don't know the type of import function
  (importFn: () => Promise<any>, componentName?: string, FallbackComponent?: ComponentType) => {
    const defaultKey = componentName ?? 'default';
    const ComponentToRender = lazy(() => importFn().then(module => ({ default: module[defaultKey] })));

    // biome-ignore lint/suspicious/noExplicitAny: we don't know the type of props
    return (props: any) => (
      <Suspense fallback={FallbackComponent ? <FallbackComponent /> : <Loader fullSize />}>
        <ComponentToRender {...props} />
      </Suspense>
    );
  };
